//      

const {DEMData} = require('../data/dem_data');

                                       
             
                            
                          
                  
                         


class RasterDEMTileWorkerSource {
                 
                                             
                                            

    constructor() {
        this.loading = {};
        this.loaded = {};
    }

    loadTile(params                         , callback                       ) {
        const source = params.source,
            uid = params.uid;

        if (!this.loading[source])
            this.loading[source] = {};

        const dem = new DEMData(uid);
        this.loading[source][uid] = dem;
        dem.loadFromImage(params.rawImageData);
        delete this.loading[source][uid];

        this.loaded[source] = this.loaded[source] || {};
        this.loaded[source][uid] = dem;
        callback(null, dem);
    }

    removeTile(params                ) {
        const loaded = this.loaded[params.source],
            uid = params.uid;
        if (loaded && loaded[uid]) {
            delete loaded[uid];
        }
    }
}

module.exports = RasterDEMTileWorkerSource;
